export const AFRICAN_DIAL_CODES = [
  { country: 'Algeria', code: '+213' },
  { country: 'Angola', code: '+244' },
  { country: 'Benin', code: '+229' },
  { country: 'Botswana', code: '+267' },
  { country: 'Burkina Faso', code: '+226' },
  { country: 'Burundi', code: '+257' },
  { country: 'Cabo Verde', code: '+238' },
  { country: 'Cameroon', code: '+237' },
  { country: 'Central African Republic', code: '+236' },
  { country: 'Chad', code: '+235' },
  { country: 'Comoros', code: '+269' },
  { country: 'Congo', code: '+242' },
  { country: 'DR Congo', code: '+243' },
  { country: "Cote d'Ivoire", code: '+225' },
  { country: 'Djibouti', code: '+253' },
  { country: 'Egypt', code: '+20' },
  { country: 'Equatorial Guinea', code: '+240' },
  { country: 'Eritrea', code: '+291' },
  { country: 'Eswatini', code: '+268' },
  { country: 'Ethiopia', code: '+251' },
  { country: 'Gabon', code: '+241' },
  { country: 'Gambia', code: '+220' },
  { country: 'Ghana', code: '+233' },
  { country: 'Guinea', code: '+224' },
  { country: 'Guinea-Bissau', code: '+245' },
  { country: 'Kenya', code: '+254' },
  { country: 'Lesotho', code: '+266' },
  { country: 'Liberia', code: '+231' },
  { country: 'Libya', code: '+218' },
  { country: 'Madagascar', code: '+261' },
  { country: 'Malawi', code: '+265' },
  { country: 'Mali', code: '+223' },
  { country: 'Mauritania', code: '+222' },
  { country: 'Mauritius', code: '+230' },
  { country: 'Morocco', code: '+212' },
  { country: 'Mozambique', code: '+258' },
  { country: 'Namibia', code: '+264' },
  { country: 'Niger', code: '+227' },
  { country: 'Nigeria', code: '+234' },
  { country: 'Rwanda', code: '+250' },
  { country: 'Sao Tome and Principe', code: '+239' },
  { country: 'Senegal', code: '+221' },
  { country: 'Seychelles', code: '+248' },
  { country: 'Sierra Leone', code: '+232' },
  { country: 'Somalia', code: '+252' },
  { country: 'South Africa', code: '+27' },
  { country: 'South Sudan', code: '+211' },
  { country: 'Sudan', code: '+249' },
  { country: 'Tanzania', code: '+255' },
  { country: 'Togo', code: '+228' },
  { country: 'Tunisia', code: '+216' },
  { country: 'Uganda', code: '+256' },
  { country: 'Zambia', code: '+260' },
  { country: 'Zimbabwe', code: '+263' },
] as const;

export const AFRICAN_COUNTRIES = AFRICAN_DIAL_CODES.map((entry) => entry.country);

export const SIGNUP_LANGUAGE_OPTIONS = [
  { code: 'en', label: 'EN' },
  { code: 'sw', label: 'KISW' },
  { code: 'fr', label: 'FR' },
  { code: 'rw', label: 'RW' },
] as const;
